import { useEffect, useState } from "react";
import Concert from "./Concert";

function FutureConcerts() {
  const [concerts, setConcerts] = useState([]);

  useEffect(() => {
    fetch(`/futureConcerts.json?timestamp=${new Date().getTime()}`)
      .then((response) => response.json())
      .then((data) => setConcerts(data));
  }, []);

  if (concerts.length === 0) {
    return <div></div>;
  }

  return (
    <div id='futureConcerts'>
      <h2 className='centered headerRad sectionHeader'>
        Προσεχείς εμφανίσεις
      </h2>
      <div className='row centered'>
        <div>
          {concerts.map((concert) => (
            <Concert key={concert.id} concert={concert} />
          ))}
        </div>
      </div>
      <hr className='sectionSeparator' />
    </div>
  );
}

export default FutureConcerts;
